const containerTransportGrid_columns = {
	"general.freight.grid.orderRef": "Consignment Number",
	"general.freight.grid.clientPo": "Customer Reference",
	"general.freight.grid.accountCode": "Account Code"
};

export { containerTransportGrid_columns };
